/**
 * Created by chensheng on 2018/6/23.
 */
import React from 'react'



class WKTranslateScroll extends React.Component {
    constructor(props) {
        super(props)

        this.addKeyFrames = this.addKeyFrames.bind(this)
        this.clickPay = this.clickPay.bind(this)
    }

    componentDidMount() {
        let {scrollId,direction} = this.props

        let partHeight = document.querySelector('#' + scrollId + ' .scroll-list__part').offsetHeight // 一份数据的高度
        let partWidth = document.querySelector('#' + scrollId + ' .scroll-list__part').offsetWidth // 一份数据的宽度

        let heightOrWidth = direction === 'x'?partWidth:partHeight

        this.addKeyFrames('-' + heightOrWidth + 'px',direction) // 设置keyframes
    }

    addKeyFrames(num,direction) {
        let style = document.createElement('style');
        let {speed,scrollId} = this.props
        style.type = 'text/css';
        let keyFrames = '\
            @-webkit-keyframes '+scrollId + ' {\
                0% {\
                    -webkit-transform: translate3d(0, 0, 0);\
                    transform: translate3d(0, 0, 0);\
                }\
                100% {\
                    -webkit-transform: translate3d(A_DYNAMIC_VALUE);\
                    transform: translate3d(A_DYNAMIC_VALUE);\
                }\
            }\
            @keyframes '+scrollId + ' {\
                0% {\
                    -webkit-transform: translate3d(0, 0, 0);\
                    transform: translate3d(0, 0, 0);\
                }\
                100% {\
                    -webkit-transform: translate3d( A_DYNAMIC_VALUE);\
                    transform: translate3d(A_DYNAMIC_VALUE);\
                }\
            }\
            .scroll-list #'+scrollId + '{\
                animation: A_SPEED '+scrollId + ' linear infinite normal;\
                position: relative;\
            }';
        let NUM_DYNAMIC = direction === 'x'?num + ',0,0':'0,'+num+',0'
        style.innerHTML = keyFrames.replace(/A_DYNAMIC_VALUE/g, NUM_DYNAMIC).replace(/A_SPEED/g, `${speed}s`);
        document.getElementsByTagName('head')[0].appendChild(style);
    }

    clickPay(){
        this.props.clickPay()
    }

    render() {
        let {data, type, scrollId,name} = this.props
        let dataArray = [data,data] //复制一份数据
        return (
            <div className={"scroll-list__inner " + name} id={scrollId}>
                {
                    dataArray.map((data,index) =>{
                        return (
                            <div className="scroll-list__part" key={index}>
                                {
                                    (type === 'text')&&(
                                        data.map((item,index) => {
                                            return <div key={index} className="item" onClick={() => this.clickPay()}>{item.title}</div>
                                        })
                                    )
                                }
                                {
                                    (type === 'image')&&(
                                        data.map((item,index)=> {
                                            return <div key={index} className="item" onClick={() => this.clickPay()}><img src={item.url}/></div>
                                        })
                                    )
                                }
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}

export default WKTranslateScroll



// WEBPACK FOOTER //
// ./src/components/wk/WKTranslateScroll.js